import { Box, Typography, styled } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import React from 'react';

const StyledIcon = styled(EditNoteIcon)(({ theme }) => ({
    color: theme.palette.text.secondary,
}));

const EditUserHeader: React.FC = () => {
    return (
        <Box display="flex" flexDirection="column" mb={6}>
            <Box display="flex" gap={3} alignItems="center">
                <StyledIcon fontSize="large" />
                <Typography
                    variant="h4"
                    lineHeight="123.5%"
                    fontSize="34px"
                    letterSpacing="0.25px"
                    fontWeight={400}
                >
                    Edit User
                </Typography>
            </Box>
        </Box>
    );
};

export default EditUserHeader;
